// src/components/WelcomePage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Button, Typography, Box, Fade, Menu, MenuItem } from '@mui/material';
import './WelcomePage.css';

const WelcomePage = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleContactClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleAdminLogin = () => {
    navigate('/admin-login');
  };
  const logoUrl = process.env.PUBLIC_URL + '/logo.jpeg';
  return (
    <div className="welcome-page">
      {/* Animated Background */}
      <div className="animated-background">
        <div className="gradient-overlay"></div>
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
          <div className="shape shape-5"></div>
          <div className="shape shape-6"></div>
          <div className="shape shape-7"></div>
          <div className="shape shape-8"></div>
          <div className="shape shape-9"></div>
          <div className="shape shape-10"></div>
          <div className="shape shape-11"></div>
          <div className="shape shape-12"></div>
          <div className="shape shape-13"></div>
          <div className="shape shape-14"></div>
          <div className="shape shape-15"></div>
        </div>
      </div>

      <AppBar position="fixed" className="app-bar" elevation={0}>
        <Toolbar>
          <img src={logoUrl} alt="Logo" className="brand-logo" />
          <Typography variant="h6" component="div" className="brand-name">
          SHREE DHANESHWARI FINANCE AND LEASING
          </Typography>
          <div className="nav-buttons">
            <Button color="inherit" onClick={handleAdminLogin} className="nav-button admin-login-btn">
              Admin Login
            </Button>
            <Button color="inherit" onClick={handleContactClick} className="nav-button">
              Contact
            </Button>
          </div>
        </Toolbar>
      </AppBar>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleClose}>Address: Kasgi , Osmanabad</MenuItem>
        <MenuItem onClick={handleClose}>Phone: +91 9123456789</MenuItem>
      </Menu>
      <Fade in={true} timeout={1000}>
        <Box className="welcome-content">
          <div className="logo-container">
            <img src={logoUrl} alt="Logo" className="welcome-logo" />
          </div>
          <Typography variant="h3" component="h1" className="welcome-title" gutterBottom>
            Welcome to SHREE DHANESHWARI FINANCE AND LEASING
          </Typography>
          <Typography variant="body1" className="welcome-subtitle">
            Please select your login type from the top navigation.
          </Typography>
        </Box>
      </Fade>
    </div>
  );
};
export default WelcomePage;